exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-bold {\n\tfont-weight: 600 !important;\n}\n\n.text-capitalize-first {\n\tdisplay: inline-block;\n}\n\n.text-capitalize-first:first-letter {\n\ttext-transform: uppercase !important;\n}\n", ""]);

// exports
